import { h, Fragment } from "preact";
import SizeGuideTrigger from "../size-guide/size-guide-trigger";
import SwatchRequestTrigger from "../swatch-request/swatch-request-trigger";

const SWATCH_REQUEST_OPTION_NAME = "Color";

export default function ProductOptionSwatchHeader({
  optionName,
  optionLabel = optionName,
  selectedOptionValue,
  sizeGuide,
  swatchRequestUrl,
}) {
  const showSizeGuide = sizeGuide && optionName === "Size";
  const showSwatchRequest =
    swatchRequestUrl && optionName === SWATCH_REQUEST_OPTION_NAME;

  return (
    <div className="product-options__option-header">
      <div className="product-options__name">
        {optionLabel}
        {selectedOptionValue ? ":" : ""}
      </div>
      {selectedOptionValue && (
        <div className="product-options__selected-value">
          {selectedOptionValue}
        </div>
      )}
      {showSizeGuide && <SizeGuideTrigger sizeGuide={sizeGuide} />}
      {showSwatchRequest && (
        <SwatchRequestTrigger productUrl={swatchRequestUrl} />
      )}
    </div>
  );
}
